/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Name_ErrorInputs */

const en_us2_profile_editors_name_error = /** @type {(inputs: Profile_Editors_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use 1 to 60 characters.`)
};

const pt_br2_profile_editors_name_error = /** @type {(inputs: Profile_Editors_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use de 1 a 60 caracteres.`)
};

const es_419_profile_editors_name_error = /** @type {(inputs: Profile_Editors_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa de 1 a 60 caracteres.`)
};

const pt_pt2_profile_editors_name_error = /** @type {(inputs: Profile_Editors_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa entre 1 e 60 caracteres.`)
};

const fr_fr2_profile_editors_name_error = /** @type {(inputs: Profile_Editors_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre 1 et 60 caractères.`)
};

const de_de2_profile_editors_name_error = /** @type {(inputs: Profile_Editors_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 bis 60 Zeichen.`)
};

const it_it2_profile_editors_name_error = /** @type {(inputs: Profile_Editors_Name_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa da 1 a 60 caratteri.`)
};

/**
* | output |
* | --- |
* | "Use 1 to 60 characters." |
*
* @param {Profile_Editors_Name_ErrorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_name_error = /** @type {((inputs?: Profile_Editors_Name_ErrorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Name_ErrorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_name_error(inputs)
	if (locale === "es-419") return es_419_profile_editors_name_error(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_name_error(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_name_error(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_name_error(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_name_error(inputs)
	return en_us2_profile_editors_name_error(inputs)
});
export { profile_editors_name_error as "profile-editors.name_error" }